var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _text, _polyline;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutcomes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.08 148.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#11ccea;}.cls-2{font-size:23.24px;font-family:Allstar4;}.cls-3{fill:none;stroke:#11ccea;stroke-miterlimit:10;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.58,364.52h13.1c2.62,0,3.86,1.22,3.86,3.82V453a3.19,3.19,0,0,1-3.47,3.48H171.32a3.2,3.2,0,0,1-3.47-3.49V383a3.29,3.29,0,0,1,3.58-3.59c4.12,0,8.25,0,12.37,0,.82,0,1-.22,1-1q0-33.13,0-66.28a6.07,6.07,0,0,1,.2-1.75,2.93,2.93,0,0,1,2.74-2c.59,0,1.19,0,1.78,0H269c2.49,0,3.63,1.13,3.63,3.61v52.58Zm-99.5,86.74H284.36V370.8c0-1.1,0-1.1-1.11-1.1q-16.39,0-32.79,0a1.71,1.71,0,0,0-1.58.85c-2.86,4.06-5.78,8.09-8.62,12.17a4.08,4.08,0,0,1-3.69,1.91q-31.14,0-62.29,0h-1.2Zm94.26-137.69H190.08v65.84h45.39a1.26,1.26,0,0,0,1.18-.61c2-2.8,3.94-5.59,5.91-8.38a7.76,7.76,0,0,0,.42-.74H199.23V364.5h68.11Z",
    transform: "translate(-160.46 -308.32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.43,400.4a15.13,15.13,0,1,1-14.85-14.94A15,15,0,0,1,273.43,400.4Zm-15.18,9.68a9.72,9.72,0,1,0-9.88-9.74A9.82,9.82,0,0,0,258.25,410.08Z",
    transform: "translate(-160.46 -308.32)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.87,438.21a19.45,19.45,0,0,1,38.81-2.4c.11,1.41.12,2.82.1,4.23a2.59,2.59,0,1,1-5.18-.06,21.73,21.73,0,0,0-.64-6.62,14.39,14.39,0,0,0-14.57-9.91,14.23,14.23,0,0,0-13.24,12.28c-.18,1.42-.07,2.88-.11,4.31a2.6,2.6,0,0,1-3.74,2.42,2.37,2.37,0,0,1-1.42-2.14C238.85,439.53,238.87,438.74,238.87,438.21Z",
    transform: "translate(-160.46 -308.32)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.11,446.26v-5.09h20.14v5.09Z",
    transform: "translate(-160.46 -308.32)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.13,432.22h12.65v5.07H178.13Z",
    transform: "translate(-160.46 -308.32)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.22,342v-5.06c.33,0,.63-.05.93-.05q28.56,0,57.12,0c.8,0,1,.25,1,1-.05,1.35,0,2.71,0,4.12Z",
    transform: "translate(-160.46 -308.32)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.24,328.22v-5.08h38.2v5.08Z",
    transform: "translate(-160.46 -308.32)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.19,350.79v5.07H222.31v-5.07Z",
    transform: "translate(-160.46 -308.32)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.79,350.78v5.07H199.26v-5.07Z",
    transform: "translate(-160.46 -308.32)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.19,323.14v5.09H243.38v-5.09Z",
    transform: "translate(-160.46 -308.32)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2.51 62.84)"
  }, "X")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.56 28.14 8.26 33.5 18.98 16.75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomes);
export default __webpack_public_path__ + "static/media/outcomes.b3953cef0d7414d5302662066d7d7c0e.svg";
export { ForwardRef as ReactComponent };